__turbopack_context__.v({
  "backdrop": "umZRfq_backdrop",
  "config": "umZRfq_config",
  "configContents": "umZRfq_configContents",
  "content": "umZRfq_content",
  "content2": "umZRfq_content2",
  "contentOne": "umZRfq_contentOne",
  "contentTwo": "umZRfq_contentTwo",
  "heroTitle": "umZRfq_heroTitle",
  "imgContainer": "umZRfq_imgContainer",
  "imgDesktop": "umZRfq_imgDesktop",
  "imgMobile": "umZRfq_imgMobile",
  "root": "umZRfq_root",
});
